/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = protobuf;

const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const MSG = $root.MSG = (() => {

    const MSG = {};

    MSG.MsgType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "SYNC"] = 0;
        values[valuesById[1] = "HALL"] = 1;
        values[valuesById[2] = "GAME"] = 2;
        values[valuesById[3] = "PING"] = 3;
        values[valuesById[4] = "PONG"] = 4;
        values[valuesById[5] = "FPS_SYNC"] = 5;
        return values;
    })();

    MSG.Msg = (function() {

        function Msg(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Msg.prototype.msgType = 0;

        Msg.create = function create(properties) {
            return new Msg(properties);
        };

        Msg.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            return w;
        };

        Msg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        Msg.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.Msg();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        Msg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        Msg.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            return null;
        };

        Msg.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.Msg)
                return d;
            var m = new $root.MSG.Msg();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            return m;
        };

        Msg.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            return d;
        };

        Msg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Msg;
    })();

    MSG.SCSubGameSync = (function() {

        function SCSubGameSync(p) {
            this.syncs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SCSubGameSync.prototype.msgType = 0;
        SCSubGameSync.prototype.seat = 0;
        SCSubGameSync.prototype.syncs = $util.emptyArray;

        SCSubGameSync.create = function create(properties) {
            return new SCSubGameSync(properties);
        };

        SCSubGameSync.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.seat != null && Object.hasOwnProperty.call(m, "seat"))
                w.uint32(16).int32(m.seat);
            if (m.syncs != null && m.syncs.length) {
                w.uint32(26).fork();
                for (var i = 0; i < m.syncs.length; ++i)
                    w.float(m.syncs[i]);
                w.ldelim();
            }
            return w;
        };

        SCSubGameSync.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SCSubGameSync.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SCSubGameSync();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.seat = r.int32();
                    break;
                case 3:
                    if (!(m.syncs && m.syncs.length))
                        m.syncs = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.syncs.push(r.float());
                    } else
                        m.syncs.push(r.float());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SCSubGameSync.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SCSubGameSync.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.seat != null && m.hasOwnProperty("seat")) {
                if (!$util.isInteger(m.seat))
                    return "seat: integer expected";
            }
            if (m.syncs != null && m.hasOwnProperty("syncs")) {
                if (!Array.isArray(m.syncs))
                    return "syncs: array expected";
                for (var i = 0; i < m.syncs.length; ++i) {
                    if (typeof m.syncs[i] !== "number")
                        return "syncs: number[] expected";
                }
            }
            return null;
        };

        SCSubGameSync.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SCSubGameSync)
                return d;
            var m = new $root.MSG.SCSubGameSync();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.seat != null) {
                m.seat = d.seat | 0;
            }
            if (d.syncs) {
                if (!Array.isArray(d.syncs))
                    throw TypeError(".MSG.SCSubGameSync.syncs: array expected");
                m.syncs = [];
                for (var i = 0; i < d.syncs.length; ++i) {
                    m.syncs[i] = Number(d.syncs[i]);
                }
            }
            return m;
        };

        SCSubGameSync.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.syncs = [];
            }
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.seat = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.seat != null && m.hasOwnProperty("seat")) {
                d.seat = m.seat;
            }
            if (m.syncs && m.syncs.length) {
                d.syncs = [];
                for (var j = 0; j < m.syncs.length; ++j) {
                    d.syncs[j] = o.json && !isFinite(m.syncs[j]) ? String(m.syncs[j]) : m.syncs[j];
                }
            }
            return d;
        };

        SCSubGameSync.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SCSubGameSync;
    })();

    MSG.SyncMessage = (function() {

        function SyncMessage(p) {
            this.syncs = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SyncMessage.prototype.msgType = 0;
        SyncMessage.prototype.fps = 0;
        SyncMessage.prototype.syncs = $util.emptyArray;

        SyncMessage.create = function create(properties) {
            return new SyncMessage(properties);
        };

        SyncMessage.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.fps != null && Object.hasOwnProperty.call(m, "fps"))
                w.uint32(16).int32(m.fps);
            if (m.syncs != null && m.syncs.length) {
                w.uint32(26).fork();
                for (var i = 0; i < m.syncs.length; ++i)
                    w.int32(m.syncs[i]);
                w.ldelim();
            }
            return w;
        };

        SyncMessage.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SyncMessage.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SyncMessage();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.fps = r.int32();
                    break;
                case 3:
                    if (!(m.syncs && m.syncs.length))
                        m.syncs = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.syncs.push(r.int32());
                    } else
                        m.syncs.push(r.int32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SyncMessage.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SyncMessage.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.fps != null && m.hasOwnProperty("fps")) {
                if (!$util.isInteger(m.fps))
                    return "fps: integer expected";
            }
            if (m.syncs != null && m.hasOwnProperty("syncs")) {
                if (!Array.isArray(m.syncs))
                    return "syncs: array expected";
                for (var i = 0; i < m.syncs.length; ++i) {
                    if (!$util.isInteger(m.syncs[i]))
                        return "syncs: integer[] expected";
                }
            }
            return null;
        };

        SyncMessage.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SyncMessage)
                return d;
            var m = new $root.MSG.SyncMessage();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.fps != null) {
                m.fps = d.fps | 0;
            }
            if (d.syncs) {
                if (!Array.isArray(d.syncs))
                    throw TypeError(".MSG.SyncMessage.syncs: array expected");
                m.syncs = [];
                for (var i = 0; i < d.syncs.length; ++i) {
                    m.syncs[i] = d.syncs[i] | 0;
                }
            }
            return m;
        };

        SyncMessage.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.syncs = [];
            }
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.fps = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.fps != null && m.hasOwnProperty("fps")) {
                d.fps = m.fps;
            }
            if (m.syncs && m.syncs.length) {
                d.syncs = [];
                for (var j = 0; j < m.syncs.length; ++j) {
                    d.syncs[j] = m.syncs[j];
                }
            }
            return d;
        };

        SyncMessage.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SyncMessage;
    })();

    MSG.FpsSyncListMsg = (function() {

        function FpsSyncListMsg(p) {
            this.seat = [];
            this.list = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        FpsSyncListMsg.prototype.msgType = 0;
        FpsSyncListMsg.prototype.frame = 0;
        FpsSyncListMsg.prototype.seat = $util.emptyArray;
        FpsSyncListMsg.prototype.list = $util.emptyArray;

        FpsSyncListMsg.create = function create(properties) {
            return new FpsSyncListMsg(properties);
        };

        FpsSyncListMsg.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.frame != null && Object.hasOwnProperty.call(m, "frame"))
                w.uint32(16).int32(m.frame);
            if (m.seat != null && m.seat.length) {
                w.uint32(26).fork();
                for (var i = 0; i < m.seat.length; ++i)
                    w.int32(m.seat[i]);
                w.ldelim();
            }
            if (m.list != null && m.list.length) {
                for (var i = 0; i < m.list.length; ++i)
                    $root.MSG.SyncMessage.encode(m.list[i], w.uint32(34).fork()).ldelim();
            }
            return w;
        };

        FpsSyncListMsg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        FpsSyncListMsg.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.FpsSyncListMsg();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.frame = r.int32();
                    break;
                case 3:
                    if (!(m.seat && m.seat.length))
                        m.seat = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.seat.push(r.int32());
                    } else
                        m.seat.push(r.int32());
                    break;
                case 4:
                    if (!(m.list && m.list.length))
                        m.list = [];
                    m.list.push($root.MSG.SyncMessage.decode(r, r.uint32()));
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        FpsSyncListMsg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        FpsSyncListMsg.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.frame != null && m.hasOwnProperty("frame")) {
                if (!$util.isInteger(m.frame))
                    return "frame: integer expected";
            }
            if (m.seat != null && m.hasOwnProperty("seat")) {
                if (!Array.isArray(m.seat))
                    return "seat: array expected";
                for (var i = 0; i < m.seat.length; ++i) {
                    if (!$util.isInteger(m.seat[i]))
                        return "seat: integer[] expected";
                }
            }
            if (m.list != null && m.hasOwnProperty("list")) {
                if (!Array.isArray(m.list))
                    return "list: array expected";
                for (var i = 0; i < m.list.length; ++i) {
                    {
                        var e = $root.MSG.SyncMessage.verify(m.list[i]);
                        if (e)
                            return "list." + e;
                    }
                }
            }
            return null;
        };

        FpsSyncListMsg.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.FpsSyncListMsg)
                return d;
            var m = new $root.MSG.FpsSyncListMsg();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.frame != null) {
                m.frame = d.frame | 0;
            }
            if (d.seat) {
                if (!Array.isArray(d.seat))
                    throw TypeError(".MSG.FpsSyncListMsg.seat: array expected");
                m.seat = [];
                for (var i = 0; i < d.seat.length; ++i) {
                    m.seat[i] = d.seat[i] | 0;
                }
            }
            if (d.list) {
                if (!Array.isArray(d.list))
                    throw TypeError(".MSG.FpsSyncListMsg.list: array expected");
                m.list = [];
                for (var i = 0; i < d.list.length; ++i) {
                    if (typeof d.list[i] !== "object")
                        throw TypeError(".MSG.FpsSyncListMsg.list: object expected");
                    m.list[i] = $root.MSG.SyncMessage.fromObject(d.list[i]);
                }
            }
            return m;
        };

        FpsSyncListMsg.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.seat = [];
                d.list = [];
            }
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.frame = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.frame != null && m.hasOwnProperty("frame")) {
                d.frame = m.frame;
            }
            if (m.seat && m.seat.length) {
                d.seat = [];
                for (var j = 0; j < m.seat.length; ++j) {
                    d.seat[j] = m.seat[j];
                }
            }
            if (m.list && m.list.length) {
                d.list = [];
                for (var j = 0; j < m.list.length; ++j) {
                    d.list[j] = $root.MSG.SyncMessage.toObject(m.list[j], o);
                }
            }
            return d;
        };

        FpsSyncListMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FpsSyncListMsg;
    })();

    MSG.HallMsg = (function() {

        function HallMsg(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        HallMsg.prototype.msgType = 0;
        HallMsg.prototype.hallHead = 0;

        HallMsg.create = function create(properties) {
            return new HallMsg(properties);
        };

        HallMsg.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.hallHead != null && Object.hasOwnProperty.call(m, "hallHead"))
                w.uint32(16).int32(m.hallHead);
            return w;
        };

        HallMsg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        HallMsg.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.HallMsg();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.hallHead = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        HallMsg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        HallMsg.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                if (!$util.isInteger(m.hallHead))
                    return "hallHead: integer expected";
            }
            return null;
        };

        HallMsg.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.HallMsg)
                return d;
            var m = new $root.MSG.HallMsg();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.hallHead != null) {
                m.hallHead = d.hallHead | 0;
            }
            return m;
        };

        HallMsg.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.hallHead = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                d.hallHead = m.hallHead;
            }
            return d;
        };

        HallMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return HallMsg;
    })();

    MSG.GameMsg = (function() {

        function GameMsg(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        GameMsg.prototype.msgType = 0;
        GameMsg.prototype.gameId = 0;
        GameMsg.prototype.gameHead = 0;

        GameMsg.create = function create(properties) {
            return new GameMsg(properties);
        };

        GameMsg.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            return w;
        };

        GameMsg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        GameMsg.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.GameMsg();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        GameMsg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        GameMsg.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            return null;
        };

        GameMsg.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.GameMsg)
                return d;
            var m = new $root.MSG.GameMsg();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            return m;
        };

        GameMsg.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            return d;
        };

        GameMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GameMsg;
    })();

    MSG.CSubLoginServer = (function() {

        function CSubLoginServer(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CSubLoginServer.prototype.msgType = 0;
        CSubLoginServer.prototype.hallHead = 0;
        CSubLoginServer.prototype.userId = "";

        CSubLoginServer.create = function create(properties) {
            return new CSubLoginServer(properties);
        };

        CSubLoginServer.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.hallHead != null && Object.hasOwnProperty.call(m, "hallHead"))
                w.uint32(16).int32(m.hallHead);
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(26).string(m.userId);
            return w;
        };

        CSubLoginServer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        CSubLoginServer.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.CSubLoginServer();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.hallHead = r.int32();
                    break;
                case 3:
                    m.userId = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        CSubLoginServer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        CSubLoginServer.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                if (!$util.isInteger(m.hallHead))
                    return "hallHead: integer expected";
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isString(m.userId))
                    return "userId: string expected";
            }
            return null;
        };

        CSubLoginServer.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.CSubLoginServer)
                return d;
            var m = new $root.MSG.CSubLoginServer();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.hallHead != null) {
                m.hallHead = d.hallHead | 0;
            }
            if (d.userId != null) {
                m.userId = String(d.userId);
            }
            return m;
        };

        CSubLoginServer.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.hallHead = 0;
                d.userId = "";
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                d.hallHead = m.hallHead;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                d.userId = m.userId;
            }
            return d;
        };

        CSubLoginServer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CSubLoginServer;
    })();

    MSG.SSubLoginServer = (function() {

        function SSubLoginServer(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubLoginServer.prototype.msgType = 0;
        SSubLoginServer.prototype.hallHead = 0;
        SSubLoginServer.prototype.userId = "";

        SSubLoginServer.create = function create(properties) {
            return new SSubLoginServer(properties);
        };

        SSubLoginServer.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.hallHead != null && Object.hasOwnProperty.call(m, "hallHead"))
                w.uint32(16).int32(m.hallHead);
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(26).string(m.userId);
            return w;
        };

        SSubLoginServer.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubLoginServer.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubLoginServer();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.hallHead = r.int32();
                    break;
                case 3:
                    m.userId = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubLoginServer.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubLoginServer.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                if (!$util.isInteger(m.hallHead))
                    return "hallHead: integer expected";
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isString(m.userId))
                    return "userId: string expected";
            }
            return null;
        };

        SSubLoginServer.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubLoginServer)
                return d;
            var m = new $root.MSG.SSubLoginServer();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.hallHead != null) {
                m.hallHead = d.hallHead | 0;
            }
            if (d.userId != null) {
                m.userId = String(d.userId);
            }
            return m;
        };

        SSubLoginServer.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.hallHead = 0;
                d.userId = "";
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                d.hallHead = m.hallHead;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                d.userId = m.userId;
            }
            return d;
        };

        SSubLoginServer.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubLoginServer;
    })();

    MSG.CSubLogoutGame = (function() {

        function CSubLogoutGame(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CSubLogoutGame.prototype.msgType = 0;
        CSubLogoutGame.prototype.hallHead = 0;

        CSubLogoutGame.create = function create(properties) {
            return new CSubLogoutGame(properties);
        };

        CSubLogoutGame.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.hallHead != null && Object.hasOwnProperty.call(m, "hallHead"))
                w.uint32(16).int32(m.hallHead);
            return w;
        };

        CSubLogoutGame.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        CSubLogoutGame.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.CSubLogoutGame();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.hallHead = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        CSubLogoutGame.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        CSubLogoutGame.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                if (!$util.isInteger(m.hallHead))
                    return "hallHead: integer expected";
            }
            return null;
        };

        CSubLogoutGame.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.CSubLogoutGame)
                return d;
            var m = new $root.MSG.CSubLogoutGame();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.hallHead != null) {
                m.hallHead = d.hallHead | 0;
            }
            return m;
        };

        CSubLogoutGame.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.hallHead = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                d.hallHead = m.hallHead;
            }
            return d;
        };

        CSubLogoutGame.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CSubLogoutGame;
    })();

    MSG.SSubLogoutGame = (function() {

        function SSubLogoutGame(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubLogoutGame.prototype.msgType = 0;
        SSubLogoutGame.prototype.hallHead = 0;

        SSubLogoutGame.create = function create(properties) {
            return new SSubLogoutGame(properties);
        };

        SSubLogoutGame.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.hallHead != null && Object.hasOwnProperty.call(m, "hallHead"))
                w.uint32(16).int32(m.hallHead);
            return w;
        };

        SSubLogoutGame.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubLogoutGame.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubLogoutGame();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.hallHead = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubLogoutGame.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubLogoutGame.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                if (!$util.isInteger(m.hallHead))
                    return "hallHead: integer expected";
            }
            return null;
        };

        SSubLogoutGame.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubLogoutGame)
                return d;
            var m = new $root.MSG.SSubLogoutGame();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.hallHead != null) {
                m.hallHead = d.hallHead | 0;
            }
            return m;
        };

        SSubLogoutGame.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.hallHead = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                d.hallHead = m.hallHead;
            }
            return d;
        };

        SSubLogoutGame.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubLogoutGame;
    })();

    MSG.CSubLoginGame = (function() {

        function CSubLoginGame(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CSubLoginGame.prototype.msgType = 0;
        CSubLoginGame.prototype.hallHead = 0;
        CSubLoginGame.prototype.gameId = 0;

        CSubLoginGame.create = function create(properties) {
            return new CSubLoginGame(properties);
        };

        CSubLoginGame.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.hallHead != null && Object.hasOwnProperty.call(m, "hallHead"))
                w.uint32(16).int32(m.hallHead);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(24).int32(m.gameId);
            return w;
        };

        CSubLoginGame.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        CSubLoginGame.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.CSubLoginGame();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.hallHead = r.int32();
                    break;
                case 3:
                    m.gameId = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        CSubLoginGame.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        CSubLoginGame.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                if (!$util.isInteger(m.hallHead))
                    return "hallHead: integer expected";
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            return null;
        };

        CSubLoginGame.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.CSubLoginGame)
                return d;
            var m = new $root.MSG.CSubLoginGame();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.hallHead != null) {
                m.hallHead = d.hallHead | 0;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            return m;
        };

        CSubLoginGame.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.hallHead = 0;
                d.gameId = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                d.hallHead = m.hallHead;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            return d;
        };

        CSubLoginGame.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CSubLoginGame;
    })();

    MSG.SSubLoginGame = (function() {

        function SSubLoginGame(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubLoginGame.prototype.msgType = 0;
        SSubLoginGame.prototype.hallHead = 0;
        SSubLoginGame.prototype.gameId = 0;
        SSubLoginGame.prototype.loginCode = 0;
        SSubLoginGame.prototype.loginMsg = "";

        SSubLoginGame.create = function create(properties) {
            return new SSubLoginGame(properties);
        };

        SSubLoginGame.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.hallHead != null && Object.hasOwnProperty.call(m, "hallHead"))
                w.uint32(16).int32(m.hallHead);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(24).int32(m.gameId);
            if (m.loginCode != null && Object.hasOwnProperty.call(m, "loginCode"))
                w.uint32(32).int32(m.loginCode);
            if (m.loginMsg != null && Object.hasOwnProperty.call(m, "loginMsg"))
                w.uint32(42).string(m.loginMsg);
            return w;
        };

        SSubLoginGame.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubLoginGame.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubLoginGame();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.hallHead = r.int32();
                    break;
                case 3:
                    m.gameId = r.int32();
                    break;
                case 4:
                    m.loginCode = r.int32();
                    break;
                case 5:
                    m.loginMsg = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubLoginGame.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubLoginGame.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                if (!$util.isInteger(m.hallHead))
                    return "hallHead: integer expected";
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.loginCode != null && m.hasOwnProperty("loginCode")) {
                if (!$util.isInteger(m.loginCode))
                    return "loginCode: integer expected";
            }
            if (m.loginMsg != null && m.hasOwnProperty("loginMsg")) {
                if (!$util.isString(m.loginMsg))
                    return "loginMsg: string expected";
            }
            return null;
        };

        SSubLoginGame.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubLoginGame)
                return d;
            var m = new $root.MSG.SSubLoginGame();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.hallHead != null) {
                m.hallHead = d.hallHead | 0;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.loginCode != null) {
                m.loginCode = d.loginCode | 0;
            }
            if (d.loginMsg != null) {
                m.loginMsg = String(d.loginMsg);
            }
            return m;
        };

        SSubLoginGame.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.hallHead = 0;
                d.gameId = 0;
                d.loginCode = 0;
                d.loginMsg = "";
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.hallHead != null && m.hasOwnProperty("hallHead")) {
                d.hallHead = m.hallHead;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.loginCode != null && m.hasOwnProperty("loginCode")) {
                d.loginCode = m.loginCode;
            }
            if (m.loginMsg != null && m.hasOwnProperty("loginMsg")) {
                d.loginMsg = m.loginMsg;
            }
            return d;
        };

        SSubLoginGame.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubLoginGame;
    })();

    MSG.CSubExitRoom = (function() {

        function CSubExitRoom(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CSubExitRoom.prototype.msgType = 0;
        CSubExitRoom.prototype.gameId = 0;
        CSubExitRoom.prototype.gameHead = 0;

        CSubExitRoom.create = function create(properties) {
            return new CSubExitRoom(properties);
        };

        CSubExitRoom.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            return w;
        };

        CSubExitRoom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        CSubExitRoom.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.CSubExitRoom();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        CSubExitRoom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        CSubExitRoom.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            return null;
        };

        CSubExitRoom.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.CSubExitRoom)
                return d;
            var m = new $root.MSG.CSubExitRoom();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            return m;
        };

        CSubExitRoom.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            return d;
        };

        CSubExitRoom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CSubExitRoom;
    })();

    MSG.SSubExitRoom = (function() {

        function SSubExitRoom(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubExitRoom.prototype.msgType = 0;
        SSubExitRoom.prototype.gameId = 0;
        SSubExitRoom.prototype.gameHead = 0;
        SSubExitRoom.prototype.uid = "";
        SSubExitRoom.prototype.rid = 0;

        SSubExitRoom.create = function create(properties) {
            return new SSubExitRoom(properties);
        };

        SSubExitRoom.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.uid != null && Object.hasOwnProperty.call(m, "uid"))
                w.uint32(34).string(m.uid);
            if (m.rid != null && Object.hasOwnProperty.call(m, "rid"))
                w.uint32(40).int32(m.rid);
            return w;
        };

        SSubExitRoom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubExitRoom.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubExitRoom();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    m.uid = r.string();
                    break;
                case 5:
                    m.rid = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubExitRoom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubExitRoom.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.uid != null && m.hasOwnProperty("uid")) {
                if (!$util.isString(m.uid))
                    return "uid: string expected";
            }
            if (m.rid != null && m.hasOwnProperty("rid")) {
                if (!$util.isInteger(m.rid))
                    return "rid: integer expected";
            }
            return null;
        };

        SSubExitRoom.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubExitRoom)
                return d;
            var m = new $root.MSG.SSubExitRoom();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.uid != null) {
                m.uid = String(d.uid);
            }
            if (d.rid != null) {
                m.rid = d.rid | 0;
            }
            return m;
        };

        SSubExitRoom.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
                d.uid = "";
                d.rid = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.uid != null && m.hasOwnProperty("uid")) {
                d.uid = m.uid;
            }
            if (m.rid != null && m.hasOwnProperty("rid")) {
                d.rid = m.rid;
            }
            return d;
        };

        SSubExitRoom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubExitRoom;
    })();

    MSG.CSubMatchRoom = (function() {

        function CSubMatchRoom(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CSubMatchRoom.prototype.msgType = 0;
        CSubMatchRoom.prototype.gameId = 0;
        CSubMatchRoom.prototype.gameHead = 0;
        CSubMatchRoom.prototype.rmId = 0;
        CSubMatchRoom.prototype.name = "";

        CSubMatchRoom.create = function create(properties) {
            return new CSubMatchRoom(properties);
        };

        CSubMatchRoom.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.rmId != null && Object.hasOwnProperty.call(m, "rmId"))
                w.uint32(32).int32(m.rmId);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                w.uint32(42).string(m.name);
            return w;
        };

        CSubMatchRoom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        CSubMatchRoom.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.CSubMatchRoom();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    m.rmId = r.int32();
                    break;
                case 5:
                    m.name = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        CSubMatchRoom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        CSubMatchRoom.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.rmId != null && m.hasOwnProperty("rmId")) {
                if (!$util.isInteger(m.rmId))
                    return "rmId: integer expected";
            }
            if (m.name != null && m.hasOwnProperty("name")) {
                if (!$util.isString(m.name))
                    return "name: string expected";
            }
            return null;
        };

        CSubMatchRoom.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.CSubMatchRoom)
                return d;
            var m = new $root.MSG.CSubMatchRoom();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.rmId != null) {
                m.rmId = d.rmId | 0;
            }
            if (d.name != null) {
                m.name = String(d.name);
            }
            return m;
        };

        CSubMatchRoom.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
                d.rmId = 0;
                d.name = "";
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.rmId != null && m.hasOwnProperty("rmId")) {
                d.rmId = m.rmId;
            }
            if (m.name != null && m.hasOwnProperty("name")) {
                d.name = m.name;
            }
            return d;
        };

        CSubMatchRoom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CSubMatchRoom;
    })();

    MSG.SSubMatchRoom = (function() {

        function SSubMatchRoom(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubMatchRoom.prototype.msgType = 0;
        SSubMatchRoom.prototype.gameId = 0;
        SSubMatchRoom.prototype.gameHead = 0;
        SSubMatchRoom.prototype.roomId = 0;
        SSubMatchRoom.prototype.userId = "";
        SSubMatchRoom.prototype.seatI = 0;
        SSubMatchRoom.prototype.roomName = "";
        SSubMatchRoom.prototype.userName = "";

        SSubMatchRoom.create = function create(properties) {
            return new SSubMatchRoom(properties);
        };

        SSubMatchRoom.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.roomId != null && Object.hasOwnProperty.call(m, "roomId"))
                w.uint32(32).int32(m.roomId);
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(42).string(m.userId);
            if (m.seatI != null && Object.hasOwnProperty.call(m, "seatI"))
                w.uint32(48).int32(m.seatI);
            if (m.roomName != null && Object.hasOwnProperty.call(m, "roomName"))
                w.uint32(58).string(m.roomName);
            if (m.userName != null && Object.hasOwnProperty.call(m, "userName"))
                w.uint32(66).string(m.userName);
            return w;
        };

        SSubMatchRoom.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubMatchRoom.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubMatchRoom();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    m.roomId = r.int32();
                    break;
                case 5:
                    m.userId = r.string();
                    break;
                case 6:
                    m.seatI = r.int32();
                    break;
                case 7:
                    m.roomName = r.string();
                    break;
                case 8:
                    m.userName = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubMatchRoom.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubMatchRoom.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.roomId != null && m.hasOwnProperty("roomId")) {
                if (!$util.isInteger(m.roomId))
                    return "roomId: integer expected";
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isString(m.userId))
                    return "userId: string expected";
            }
            if (m.seatI != null && m.hasOwnProperty("seatI")) {
                if (!$util.isInteger(m.seatI))
                    return "seatI: integer expected";
            }
            if (m.roomName != null && m.hasOwnProperty("roomName")) {
                if (!$util.isString(m.roomName))
                    return "roomName: string expected";
            }
            if (m.userName != null && m.hasOwnProperty("userName")) {
                if (!$util.isString(m.userName))
                    return "userName: string expected";
            }
            return null;
        };

        SSubMatchRoom.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubMatchRoom)
                return d;
            var m = new $root.MSG.SSubMatchRoom();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.roomId != null) {
                m.roomId = d.roomId | 0;
            }
            if (d.userId != null) {
                m.userId = String(d.userId);
            }
            if (d.seatI != null) {
                m.seatI = d.seatI | 0;
            }
            if (d.roomName != null) {
                m.roomName = String(d.roomName);
            }
            if (d.userName != null) {
                m.userName = String(d.userName);
            }
            return m;
        };

        SSubMatchRoom.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
                d.roomId = 0;
                d.userId = "";
                d.seatI = 0;
                d.roomName = "";
                d.userName = "";
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.roomId != null && m.hasOwnProperty("roomId")) {
                d.roomId = m.roomId;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                d.userId = m.userId;
            }
            if (m.seatI != null && m.hasOwnProperty("seatI")) {
                d.seatI = m.seatI;
            }
            if (m.roomName != null && m.hasOwnProperty("roomName")) {
                d.roomName = m.roomName;
            }
            if (m.userName != null && m.hasOwnProperty("userName")) {
                d.userName = m.userName;
            }
            return d;
        };

        SSubMatchRoom.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubMatchRoom;
    })();

    MSG.CSubGetHostUid = (function() {

        function CSubGetHostUid(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CSubGetHostUid.prototype.msgType = 0;
        CSubGetHostUid.prototype.gameId = 0;
        CSubGetHostUid.prototype.gameHead = 0;

        CSubGetHostUid.create = function create(properties) {
            return new CSubGetHostUid(properties);
        };

        CSubGetHostUid.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            return w;
        };

        CSubGetHostUid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        CSubGetHostUid.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.CSubGetHostUid();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        CSubGetHostUid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        CSubGetHostUid.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            return null;
        };

        CSubGetHostUid.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.CSubGetHostUid)
                return d;
            var m = new $root.MSG.CSubGetHostUid();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            return m;
        };

        CSubGetHostUid.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            return d;
        };

        CSubGetHostUid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CSubGetHostUid;
    })();

    MSG.SSubRushLogin = (function() {

        function SSubRushLogin(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubRushLogin.prototype.msgType = 0;
        SSubRushLogin.prototype.gameId = 0;
        SSubRushLogin.prototype.gameHead = 0;

        SSubRushLogin.create = function create(properties) {
            return new SSubRushLogin(properties);
        };

        SSubRushLogin.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            return w;
        };

        SSubRushLogin.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubRushLogin.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubRushLogin();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubRushLogin.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubRushLogin.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            return null;
        };

        SSubRushLogin.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubRushLogin)
                return d;
            var m = new $root.MSG.SSubRushLogin();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            return m;
        };

        SSubRushLogin.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            return d;
        };

        SSubRushLogin.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubRushLogin;
    })();

    MSG.SSubUpdateHostUid = (function() {

        function SSubUpdateHostUid(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubUpdateHostUid.prototype.msgType = 0;
        SSubUpdateHostUid.prototype.gameId = 0;
        SSubUpdateHostUid.prototype.gameHead = 0;
        SSubUpdateHostUid.prototype.uid = "";

        SSubUpdateHostUid.create = function create(properties) {
            return new SSubUpdateHostUid(properties);
        };

        SSubUpdateHostUid.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.uid != null && Object.hasOwnProperty.call(m, "uid"))
                w.uint32(34).string(m.uid);
            return w;
        };

        SSubUpdateHostUid.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubUpdateHostUid.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubUpdateHostUid();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    m.uid = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubUpdateHostUid.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubUpdateHostUid.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.uid != null && m.hasOwnProperty("uid")) {
                if (!$util.isString(m.uid))
                    return "uid: string expected";
            }
            return null;
        };

        SSubUpdateHostUid.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubUpdateHostUid)
                return d;
            var m = new $root.MSG.SSubUpdateHostUid();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.uid != null) {
                m.uid = String(d.uid);
            }
            return m;
        };

        SSubUpdateHostUid.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
                d.uid = "";
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.uid != null && m.hasOwnProperty("uid")) {
                d.uid = m.uid;
            }
            return d;
        };

        SSubUpdateHostUid.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubUpdateHostUid;
    })();

    MSG.CSubPlaneMove = (function() {

        function CSubPlaneMove(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CSubPlaneMove.prototype.msgType = 0;
        CSubPlaneMove.prototype.gameId = 0;
        CSubPlaneMove.prototype.gameHead = 0;
        CSubPlaneMove.prototype.x = 0;
        CSubPlaneMove.prototype.y = 0;

        CSubPlaneMove.create = function create(properties) {
            return new CSubPlaneMove(properties);
        };

        CSubPlaneMove.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.x != null && Object.hasOwnProperty.call(m, "x"))
                w.uint32(37).float(m.x);
            if (m.y != null && Object.hasOwnProperty.call(m, "y"))
                w.uint32(45).float(m.y);
            return w;
        };

        CSubPlaneMove.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        CSubPlaneMove.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.CSubPlaneMove();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    m.x = r.float();
                    break;
                case 5:
                    m.y = r.float();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        CSubPlaneMove.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        CSubPlaneMove.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.x != null && m.hasOwnProperty("x")) {
                if (typeof m.x !== "number")
                    return "x: number expected";
            }
            if (m.y != null && m.hasOwnProperty("y")) {
                if (typeof m.y !== "number")
                    return "y: number expected";
            }
            return null;
        };

        CSubPlaneMove.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.CSubPlaneMove)
                return d;
            var m = new $root.MSG.CSubPlaneMove();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.x != null) {
                m.x = Number(d.x);
            }
            if (d.y != null) {
                m.y = Number(d.y);
            }
            return m;
        };

        CSubPlaneMove.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
                d.x = 0;
                d.y = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.x != null && m.hasOwnProperty("x")) {
                d.x = o.json && !isFinite(m.x) ? String(m.x) : m.x;
            }
            if (m.y != null && m.hasOwnProperty("y")) {
                d.y = o.json && !isFinite(m.y) ? String(m.y) : m.y;
            }
            return d;
        };

        CSubPlaneMove.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CSubPlaneMove;
    })();

    MSG.SSubPlaneMove = (function() {

        function SSubPlaneMove(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubPlaneMove.prototype.msgType = 0;
        SSubPlaneMove.prototype.gameId = 0;
        SSubPlaneMove.prototype.gameHead = 0;
        SSubPlaneMove.prototype.seat = 0;
        SSubPlaneMove.prototype.x = 0;
        SSubPlaneMove.prototype.y = 0;

        SSubPlaneMove.create = function create(properties) {
            return new SSubPlaneMove(properties);
        };

        SSubPlaneMove.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.seat != null && Object.hasOwnProperty.call(m, "seat"))
                w.uint32(32).int32(m.seat);
            if (m.x != null && Object.hasOwnProperty.call(m, "x"))
                w.uint32(45).float(m.x);
            if (m.y != null && Object.hasOwnProperty.call(m, "y"))
                w.uint32(53).float(m.y);
            return w;
        };

        SSubPlaneMove.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubPlaneMove.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubPlaneMove();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    m.seat = r.int32();
                    break;
                case 5:
                    m.x = r.float();
                    break;
                case 6:
                    m.y = r.float();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubPlaneMove.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubPlaneMove.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.seat != null && m.hasOwnProperty("seat")) {
                if (!$util.isInteger(m.seat))
                    return "seat: integer expected";
            }
            if (m.x != null && m.hasOwnProperty("x")) {
                if (typeof m.x !== "number")
                    return "x: number expected";
            }
            if (m.y != null && m.hasOwnProperty("y")) {
                if (typeof m.y !== "number")
                    return "y: number expected";
            }
            return null;
        };

        SSubPlaneMove.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubPlaneMove)
                return d;
            var m = new $root.MSG.SSubPlaneMove();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.seat != null) {
                m.seat = d.seat | 0;
            }
            if (d.x != null) {
                m.x = Number(d.x);
            }
            if (d.y != null) {
                m.y = Number(d.y);
            }
            return m;
        };

        SSubPlaneMove.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
                d.seat = 0;
                d.x = 0;
                d.y = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.seat != null && m.hasOwnProperty("seat")) {
                d.seat = m.seat;
            }
            if (m.x != null && m.hasOwnProperty("x")) {
                d.x = o.json && !isFinite(m.x) ? String(m.x) : m.x;
            }
            if (m.y != null && m.hasOwnProperty("y")) {
                d.y = o.json && !isFinite(m.y) ? String(m.y) : m.y;
            }
            return d;
        };

        SSubPlaneMove.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubPlaneMove;
    })();

    MSG.SSubObGameStart = (function() {

        function SSubObGameStart(p) {
            this.pUidList = [];
            this.pSeatList = [];
            this.pNameList = [];
            this.pScoreList = [];
            this.pPosXList = [];
            this.pPosYList = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubObGameStart.prototype.msgType = 0;
        SSubObGameStart.prototype.gameId = 0;
        SSubObGameStart.prototype.gameHead = 0;
        SSubObGameStart.prototype.pUidList = $util.emptyArray;
        SSubObGameStart.prototype.pSeatList = $util.emptyArray;
        SSubObGameStart.prototype.pNameList = $util.emptyArray;
        SSubObGameStart.prototype.pScoreList = $util.emptyArray;
        SSubObGameStart.prototype.pPosXList = $util.emptyArray;
        SSubObGameStart.prototype.pPosYList = $util.emptyArray;

        SSubObGameStart.create = function create(properties) {
            return new SSubObGameStart(properties);
        };

        SSubObGameStart.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.pUidList != null && m.pUidList.length) {
                for (var i = 0; i < m.pUidList.length; ++i)
                    w.uint32(34).string(m.pUidList[i]);
            }
            if (m.pSeatList != null && m.pSeatList.length) {
                w.uint32(42).fork();
                for (var i = 0; i < m.pSeatList.length; ++i)
                    w.int32(m.pSeatList[i]);
                w.ldelim();
            }
            if (m.pNameList != null && m.pNameList.length) {
                for (var i = 0; i < m.pNameList.length; ++i)
                    w.uint32(50).string(m.pNameList[i]);
            }
            if (m.pScoreList != null && m.pScoreList.length) {
                w.uint32(58).fork();
                for (var i = 0; i < m.pScoreList.length; ++i)
                    w.int32(m.pScoreList[i]);
                w.ldelim();
            }
            if (m.pPosXList != null && m.pPosXList.length) {
                w.uint32(66).fork();
                for (var i = 0; i < m.pPosXList.length; ++i)
                    w.int32(m.pPosXList[i]);
                w.ldelim();
            }
            if (m.pPosYList != null && m.pPosYList.length) {
                w.uint32(74).fork();
                for (var i = 0; i < m.pPosYList.length; ++i)
                    w.int32(m.pPosYList[i]);
                w.ldelim();
            }
            return w;
        };

        SSubObGameStart.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubObGameStart.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubObGameStart();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    if (!(m.pUidList && m.pUidList.length))
                        m.pUidList = [];
                    m.pUidList.push(r.string());
                    break;
                case 5:
                    if (!(m.pSeatList && m.pSeatList.length))
                        m.pSeatList = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.pSeatList.push(r.int32());
                    } else
                        m.pSeatList.push(r.int32());
                    break;
                case 6:
                    if (!(m.pNameList && m.pNameList.length))
                        m.pNameList = [];
                    m.pNameList.push(r.string());
                    break;
                case 7:
                    if (!(m.pScoreList && m.pScoreList.length))
                        m.pScoreList = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.pScoreList.push(r.int32());
                    } else
                        m.pScoreList.push(r.int32());
                    break;
                case 8:
                    if (!(m.pPosXList && m.pPosXList.length))
                        m.pPosXList = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.pPosXList.push(r.int32());
                    } else
                        m.pPosXList.push(r.int32());
                    break;
                case 9:
                    if (!(m.pPosYList && m.pPosYList.length))
                        m.pPosYList = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.pPosYList.push(r.int32());
                    } else
                        m.pPosYList.push(r.int32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubObGameStart.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubObGameStart.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.pUidList != null && m.hasOwnProperty("pUidList")) {
                if (!Array.isArray(m.pUidList))
                    return "pUidList: array expected";
                for (var i = 0; i < m.pUidList.length; ++i) {
                    if (!$util.isString(m.pUidList[i]))
                        return "pUidList: string[] expected";
                }
            }
            if (m.pSeatList != null && m.hasOwnProperty("pSeatList")) {
                if (!Array.isArray(m.pSeatList))
                    return "pSeatList: array expected";
                for (var i = 0; i < m.pSeatList.length; ++i) {
                    if (!$util.isInteger(m.pSeatList[i]))
                        return "pSeatList: integer[] expected";
                }
            }
            if (m.pNameList != null && m.hasOwnProperty("pNameList")) {
                if (!Array.isArray(m.pNameList))
                    return "pNameList: array expected";
                for (var i = 0; i < m.pNameList.length; ++i) {
                    if (!$util.isString(m.pNameList[i]))
                        return "pNameList: string[] expected";
                }
            }
            if (m.pScoreList != null && m.hasOwnProperty("pScoreList")) {
                if (!Array.isArray(m.pScoreList))
                    return "pScoreList: array expected";
                for (var i = 0; i < m.pScoreList.length; ++i) {
                    if (!$util.isInteger(m.pScoreList[i]))
                        return "pScoreList: integer[] expected";
                }
            }
            if (m.pPosXList != null && m.hasOwnProperty("pPosXList")) {
                if (!Array.isArray(m.pPosXList))
                    return "pPosXList: array expected";
                for (var i = 0; i < m.pPosXList.length; ++i) {
                    if (!$util.isInteger(m.pPosXList[i]))
                        return "pPosXList: integer[] expected";
                }
            }
            if (m.pPosYList != null && m.hasOwnProperty("pPosYList")) {
                if (!Array.isArray(m.pPosYList))
                    return "pPosYList: array expected";
                for (var i = 0; i < m.pPosYList.length; ++i) {
                    if (!$util.isInteger(m.pPosYList[i]))
                        return "pPosYList: integer[] expected";
                }
            }
            return null;
        };

        SSubObGameStart.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubObGameStart)
                return d;
            var m = new $root.MSG.SSubObGameStart();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.pUidList) {
                if (!Array.isArray(d.pUidList))
                    throw TypeError(".MSG.SSubObGameStart.pUidList: array expected");
                m.pUidList = [];
                for (var i = 0; i < d.pUidList.length; ++i) {
                    m.pUidList[i] = String(d.pUidList[i]);
                }
            }
            if (d.pSeatList) {
                if (!Array.isArray(d.pSeatList))
                    throw TypeError(".MSG.SSubObGameStart.pSeatList: array expected");
                m.pSeatList = [];
                for (var i = 0; i < d.pSeatList.length; ++i) {
                    m.pSeatList[i] = d.pSeatList[i] | 0;
                }
            }
            if (d.pNameList) {
                if (!Array.isArray(d.pNameList))
                    throw TypeError(".MSG.SSubObGameStart.pNameList: array expected");
                m.pNameList = [];
                for (var i = 0; i < d.pNameList.length; ++i) {
                    m.pNameList[i] = String(d.pNameList[i]);
                }
            }
            if (d.pScoreList) {
                if (!Array.isArray(d.pScoreList))
                    throw TypeError(".MSG.SSubObGameStart.pScoreList: array expected");
                m.pScoreList = [];
                for (var i = 0; i < d.pScoreList.length; ++i) {
                    m.pScoreList[i] = d.pScoreList[i] | 0;
                }
            }
            if (d.pPosXList) {
                if (!Array.isArray(d.pPosXList))
                    throw TypeError(".MSG.SSubObGameStart.pPosXList: array expected");
                m.pPosXList = [];
                for (var i = 0; i < d.pPosXList.length; ++i) {
                    m.pPosXList[i] = d.pPosXList[i] | 0;
                }
            }
            if (d.pPosYList) {
                if (!Array.isArray(d.pPosYList))
                    throw TypeError(".MSG.SSubObGameStart.pPosYList: array expected");
                m.pPosYList = [];
                for (var i = 0; i < d.pPosYList.length; ++i) {
                    m.pPosYList[i] = d.pPosYList[i] | 0;
                }
            }
            return m;
        };

        SSubObGameStart.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.pUidList = [];
                d.pSeatList = [];
                d.pNameList = [];
                d.pScoreList = [];
                d.pPosXList = [];
                d.pPosYList = [];
            }
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.pUidList && m.pUidList.length) {
                d.pUidList = [];
                for (var j = 0; j < m.pUidList.length; ++j) {
                    d.pUidList[j] = m.pUidList[j];
                }
            }
            if (m.pSeatList && m.pSeatList.length) {
                d.pSeatList = [];
                for (var j = 0; j < m.pSeatList.length; ++j) {
                    d.pSeatList[j] = m.pSeatList[j];
                }
            }
            if (m.pNameList && m.pNameList.length) {
                d.pNameList = [];
                for (var j = 0; j < m.pNameList.length; ++j) {
                    d.pNameList[j] = m.pNameList[j];
                }
            }
            if (m.pScoreList && m.pScoreList.length) {
                d.pScoreList = [];
                for (var j = 0; j < m.pScoreList.length; ++j) {
                    d.pScoreList[j] = m.pScoreList[j];
                }
            }
            if (m.pPosXList && m.pPosXList.length) {
                d.pPosXList = [];
                for (var j = 0; j < m.pPosXList.length; ++j) {
                    d.pPosXList[j] = m.pPosXList[j];
                }
            }
            if (m.pPosYList && m.pPosYList.length) {
                d.pPosYList = [];
                for (var j = 0; j < m.pPosYList.length; ++j) {
                    d.pPosYList[j] = m.pPosYList[j];
                }
            }
            return d;
        };

        SSubObGameStart.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubObGameStart;
    })();

    MSG.SSubNewEnemy = (function() {

        function SSubNewEnemy(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubNewEnemy.prototype.msgType = 0;
        SSubNewEnemy.prototype.gameId = 0;
        SSubNewEnemy.prototype.gameHead = 0;
        SSubNewEnemy.prototype.eid = 0;
        SSubNewEnemy.prototype.x = 0;
        SSubNewEnemy.prototype.y = 0;
        SSubNewEnemy.prototype.time = 0;
        SSubNewEnemy.prototype.hp = 0;

        SSubNewEnemy.create = function create(properties) {
            return new SSubNewEnemy(properties);
        };

        SSubNewEnemy.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.eid != null && Object.hasOwnProperty.call(m, "eid"))
                w.uint32(32).int32(m.eid);
            if (m.x != null && Object.hasOwnProperty.call(m, "x"))
                w.uint32(40).int32(m.x);
            if (m.y != null && Object.hasOwnProperty.call(m, "y"))
                w.uint32(48).int32(m.y);
            if (m.time != null && Object.hasOwnProperty.call(m, "time"))
                w.uint32(56).int32(m.time);
            if (m.hp != null && Object.hasOwnProperty.call(m, "hp"))
                w.uint32(64).int32(m.hp);
            return w;
        };

        SSubNewEnemy.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubNewEnemy.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubNewEnemy();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    m.eid = r.int32();
                    break;
                case 5:
                    m.x = r.int32();
                    break;
                case 6:
                    m.y = r.int32();
                    break;
                case 7:
                    m.time = r.int32();
                    break;
                case 8:
                    m.hp = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubNewEnemy.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubNewEnemy.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.eid != null && m.hasOwnProperty("eid")) {
                if (!$util.isInteger(m.eid))
                    return "eid: integer expected";
            }
            if (m.x != null && m.hasOwnProperty("x")) {
                if (!$util.isInteger(m.x))
                    return "x: integer expected";
            }
            if (m.y != null && m.hasOwnProperty("y")) {
                if (!$util.isInteger(m.y))
                    return "y: integer expected";
            }
            if (m.time != null && m.hasOwnProperty("time")) {
                if (!$util.isInteger(m.time))
                    return "time: integer expected";
            }
            if (m.hp != null && m.hasOwnProperty("hp")) {
                if (!$util.isInteger(m.hp))
                    return "hp: integer expected";
            }
            return null;
        };

        SSubNewEnemy.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubNewEnemy)
                return d;
            var m = new $root.MSG.SSubNewEnemy();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.eid != null) {
                m.eid = d.eid | 0;
            }
            if (d.x != null) {
                m.x = d.x | 0;
            }
            if (d.y != null) {
                m.y = d.y | 0;
            }
            if (d.time != null) {
                m.time = d.time | 0;
            }
            if (d.hp != null) {
                m.hp = d.hp | 0;
            }
            return m;
        };

        SSubNewEnemy.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
                d.eid = 0;
                d.x = 0;
                d.y = 0;
                d.time = 0;
                d.hp = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.eid != null && m.hasOwnProperty("eid")) {
                d.eid = m.eid;
            }
            if (m.x != null && m.hasOwnProperty("x")) {
                d.x = m.x;
            }
            if (m.y != null && m.hasOwnProperty("y")) {
                d.y = m.y;
            }
            if (m.time != null && m.hasOwnProperty("time")) {
                d.time = m.time;
            }
            if (m.hp != null && m.hasOwnProperty("hp")) {
                d.hp = m.hp;
            }
            return d;
        };

        SSubNewEnemy.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubNewEnemy;
    })();

    MSG.CSubObHurtEnemy = (function() {

        function CSubObHurtEnemy(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CSubObHurtEnemy.prototype.msgType = 0;
        CSubObHurtEnemy.prototype.gameId = 0;
        CSubObHurtEnemy.prototype.gameHead = 0;
        CSubObHurtEnemy.prototype.eid = 0;
        CSubObHurtEnemy.prototype.hurt = 0;

        CSubObHurtEnemy.create = function create(properties) {
            return new CSubObHurtEnemy(properties);
        };

        CSubObHurtEnemy.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.eid != null && Object.hasOwnProperty.call(m, "eid"))
                w.uint32(32).int32(m.eid);
            if (m.hurt != null && Object.hasOwnProperty.call(m, "hurt"))
                w.uint32(40).int32(m.hurt);
            return w;
        };

        CSubObHurtEnemy.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        CSubObHurtEnemy.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.CSubObHurtEnemy();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    m.eid = r.int32();
                    break;
                case 5:
                    m.hurt = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        CSubObHurtEnemy.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        CSubObHurtEnemy.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.eid != null && m.hasOwnProperty("eid")) {
                if (!$util.isInteger(m.eid))
                    return "eid: integer expected";
            }
            if (m.hurt != null && m.hasOwnProperty("hurt")) {
                if (!$util.isInteger(m.hurt))
                    return "hurt: integer expected";
            }
            return null;
        };

        CSubObHurtEnemy.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.CSubObHurtEnemy)
                return d;
            var m = new $root.MSG.CSubObHurtEnemy();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.eid != null) {
                m.eid = d.eid | 0;
            }
            if (d.hurt != null) {
                m.hurt = d.hurt | 0;
            }
            return m;
        };

        CSubObHurtEnemy.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
                d.eid = 0;
                d.hurt = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.eid != null && m.hasOwnProperty("eid")) {
                d.eid = m.eid;
            }
            if (m.hurt != null && m.hasOwnProperty("hurt")) {
                d.hurt = m.hurt;
            }
            return d;
        };

        CSubObHurtEnemy.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CSubObHurtEnemy;
    })();

    MSG.SSubUpdateHurtHp = (function() {

        function SSubUpdateHurtHp(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubUpdateHurtHp.prototype.msgType = 0;
        SSubUpdateHurtHp.prototype.gameId = 0;
        SSubUpdateHurtHp.prototype.gameHead = 0;
        SSubUpdateHurtHp.prototype.eid = 0;
        SSubUpdateHurtHp.prototype.hp = 0;

        SSubUpdateHurtHp.create = function create(properties) {
            return new SSubUpdateHurtHp(properties);
        };

        SSubUpdateHurtHp.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.eid != null && Object.hasOwnProperty.call(m, "eid"))
                w.uint32(32).int32(m.eid);
            if (m.hp != null && Object.hasOwnProperty.call(m, "hp"))
                w.uint32(40).int32(m.hp);
            return w;
        };

        SSubUpdateHurtHp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubUpdateHurtHp.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubUpdateHurtHp();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    m.eid = r.int32();
                    break;
                case 5:
                    m.hp = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubUpdateHurtHp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubUpdateHurtHp.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.eid != null && m.hasOwnProperty("eid")) {
                if (!$util.isInteger(m.eid))
                    return "eid: integer expected";
            }
            if (m.hp != null && m.hasOwnProperty("hp")) {
                if (!$util.isInteger(m.hp))
                    return "hp: integer expected";
            }
            return null;
        };

        SSubUpdateHurtHp.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubUpdateHurtHp)
                return d;
            var m = new $root.MSG.SSubUpdateHurtHp();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.eid != null) {
                m.eid = d.eid | 0;
            }
            if (d.hp != null) {
                m.hp = d.hp | 0;
            }
            return m;
        };

        SSubUpdateHurtHp.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
                d.eid = 0;
                d.hp = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.eid != null && m.hasOwnProperty("eid")) {
                d.eid = m.eid;
            }
            if (m.hp != null && m.hasOwnProperty("hp")) {
                d.hp = m.hp;
            }
            return d;
        };

        SSubUpdateHurtHp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubUpdateHurtHp;
    })();

    MSG.SSubSyncScore = (function() {

        function SSubSyncScore(p) {
            this.seats = [];
            this.scores = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubSyncScore.prototype.msgType = 0;
        SSubSyncScore.prototype.gameId = 0;
        SSubSyncScore.prototype.gameHead = 0;
        SSubSyncScore.prototype.seats = $util.emptyArray;
        SSubSyncScore.prototype.scores = $util.emptyArray;

        SSubSyncScore.create = function create(properties) {
            return new SSubSyncScore(properties);
        };

        SSubSyncScore.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.seats != null && m.seats.length) {
                w.uint32(34).fork();
                for (var i = 0; i < m.seats.length; ++i)
                    w.int32(m.seats[i]);
                w.ldelim();
            }
            if (m.scores != null && m.scores.length) {
                w.uint32(42).fork();
                for (var i = 0; i < m.scores.length; ++i)
                    w.int32(m.scores[i]);
                w.ldelim();
            }
            return w;
        };

        SSubSyncScore.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubSyncScore.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubSyncScore();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    if (!(m.seats && m.seats.length))
                        m.seats = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.seats.push(r.int32());
                    } else
                        m.seats.push(r.int32());
                    break;
                case 5:
                    if (!(m.scores && m.scores.length))
                        m.scores = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.scores.push(r.int32());
                    } else
                        m.scores.push(r.int32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubSyncScore.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubSyncScore.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.seats != null && m.hasOwnProperty("seats")) {
                if (!Array.isArray(m.seats))
                    return "seats: array expected";
                for (var i = 0; i < m.seats.length; ++i) {
                    if (!$util.isInteger(m.seats[i]))
                        return "seats: integer[] expected";
                }
            }
            if (m.scores != null && m.hasOwnProperty("scores")) {
                if (!Array.isArray(m.scores))
                    return "scores: array expected";
                for (var i = 0; i < m.scores.length; ++i) {
                    if (!$util.isInteger(m.scores[i]))
                        return "scores: integer[] expected";
                }
            }
            return null;
        };

        SSubSyncScore.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubSyncScore)
                return d;
            var m = new $root.MSG.SSubSyncScore();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.seats) {
                if (!Array.isArray(d.seats))
                    throw TypeError(".MSG.SSubSyncScore.seats: array expected");
                m.seats = [];
                for (var i = 0; i < d.seats.length; ++i) {
                    m.seats[i] = d.seats[i] | 0;
                }
            }
            if (d.scores) {
                if (!Array.isArray(d.scores))
                    throw TypeError(".MSG.SSubSyncScore.scores: array expected");
                m.scores = [];
                for (var i = 0; i < d.scores.length; ++i) {
                    m.scores[i] = d.scores[i] | 0;
                }
            }
            return m;
        };

        SSubSyncScore.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.seats = [];
                d.scores = [];
            }
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.seats && m.seats.length) {
                d.seats = [];
                for (var j = 0; j < m.seats.length; ++j) {
                    d.seats[j] = m.seats[j];
                }
            }
            if (m.scores && m.scores.length) {
                d.scores = [];
                for (var j = 0; j < m.scores.length; ++j) {
                    d.scores[j] = m.scores[j];
                }
            }
            return d;
        };

        SSubSyncScore.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubSyncScore;
    })();

    MSG.SSubKillEnemy = (function() {

        function SSubKillEnemy(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubKillEnemy.prototype.msgType = 0;
        SSubKillEnemy.prototype.gameId = 0;
        SSubKillEnemy.prototype.gameHead = 0;
        SSubKillEnemy.prototype.eid = 0;
        SSubKillEnemy.prototype.score = 0;
        SSubKillEnemy.prototype.seatId = 0;

        SSubKillEnemy.create = function create(properties) {
            return new SSubKillEnemy(properties);
        };

        SSubKillEnemy.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.eid != null && Object.hasOwnProperty.call(m, "eid"))
                w.uint32(32).int32(m.eid);
            if (m.score != null && Object.hasOwnProperty.call(m, "score"))
                w.uint32(40).int32(m.score);
            if (m.seatId != null && Object.hasOwnProperty.call(m, "seatId"))
                w.uint32(48).int32(m.seatId);
            return w;
        };

        SSubKillEnemy.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubKillEnemy.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubKillEnemy();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    m.eid = r.int32();
                    break;
                case 5:
                    m.score = r.int32();
                    break;
                case 6:
                    m.seatId = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubKillEnemy.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubKillEnemy.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.eid != null && m.hasOwnProperty("eid")) {
                if (!$util.isInteger(m.eid))
                    return "eid: integer expected";
            }
            if (m.score != null && m.hasOwnProperty("score")) {
                if (!$util.isInteger(m.score))
                    return "score: integer expected";
            }
            if (m.seatId != null && m.hasOwnProperty("seatId")) {
                if (!$util.isInteger(m.seatId))
                    return "seatId: integer expected";
            }
            return null;
        };

        SSubKillEnemy.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubKillEnemy)
                return d;
            var m = new $root.MSG.SSubKillEnemy();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.eid != null) {
                m.eid = d.eid | 0;
            }
            if (d.score != null) {
                m.score = d.score | 0;
            }
            if (d.seatId != null) {
                m.seatId = d.seatId | 0;
            }
            return m;
        };

        SSubKillEnemy.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
                d.eid = 0;
                d.score = 0;
                d.seatId = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.eid != null && m.hasOwnProperty("eid")) {
                d.eid = m.eid;
            }
            if (m.score != null && m.hasOwnProperty("score")) {
                d.score = m.score;
            }
            if (m.seatId != null && m.hasOwnProperty("seatId")) {
                d.seatId = m.seatId;
            }
            return d;
        };

        SSubKillEnemy.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubKillEnemy;
    })();

    MSG.CSubShopBullet = (function() {

        function CSubShopBullet(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CSubShopBullet.prototype.msgType = 0;
        CSubShopBullet.prototype.gameId = 0;
        CSubShopBullet.prototype.gameHead = 0;

        CSubShopBullet.create = function create(properties) {
            return new CSubShopBullet(properties);
        };

        CSubShopBullet.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            return w;
        };

        CSubShopBullet.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        CSubShopBullet.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.CSubShopBullet();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        CSubShopBullet.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        CSubShopBullet.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            return null;
        };

        CSubShopBullet.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.CSubShopBullet)
                return d;
            var m = new $root.MSG.CSubShopBullet();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            return m;
        };

        CSubShopBullet.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            return d;
        };

        CSubShopBullet.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CSubShopBullet;
    })();

    MSG.SSubShopBullet = (function() {

        function SSubShopBullet(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubShopBullet.prototype.msgType = 0;
        SSubShopBullet.prototype.gameId = 0;
        SSubShopBullet.prototype.gameHead = 0;
        SSubShopBullet.prototype.seatI = 0;

        SSubShopBullet.create = function create(properties) {
            return new SSubShopBullet(properties);
        };

        SSubShopBullet.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.seatI != null && Object.hasOwnProperty.call(m, "seatI"))
                w.uint32(32).int32(m.seatI);
            return w;
        };

        SSubShopBullet.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubShopBullet.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubShopBullet();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    m.seatI = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubShopBullet.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubShopBullet.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.seatI != null && m.hasOwnProperty("seatI")) {
                if (!$util.isInteger(m.seatI))
                    return "seatI: integer expected";
            }
            return null;
        };

        SSubShopBullet.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubShopBullet)
                return d;
            var m = new $root.MSG.SSubShopBullet();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.seatI != null) {
                m.seatI = d.seatI | 0;
            }
            return m;
        };

        SSubShopBullet.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
                d.seatI = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.seatI != null && m.hasOwnProperty("seatI")) {
                d.seatI = m.seatI;
            }
            return d;
        };

        SSubShopBullet.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubShopBullet;
    })();

    MSG.SSubFpsGameStart = (function() {

        function SSubFpsGameStart(p) {
            this.pUidList = [];
            this.pSeatList = [];
            this.pNameList = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        SSubFpsGameStart.prototype.msgType = 0;
        SSubFpsGameStart.prototype.gameId = 0;
        SSubFpsGameStart.prototype.gameHead = 0;
        SSubFpsGameStart.prototype.frameTime = 0;
        SSubFpsGameStart.prototype.pUidList = $util.emptyArray;
        SSubFpsGameStart.prototype.pSeatList = $util.emptyArray;
        SSubFpsGameStart.prototype.pNameList = $util.emptyArray;

        SSubFpsGameStart.create = function create(properties) {
            return new SSubFpsGameStart(properties);
        };

        SSubFpsGameStart.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType"))
                w.uint32(8).int32(m.msgType);
            if (m.gameId != null && Object.hasOwnProperty.call(m, "gameId"))
                w.uint32(16).int32(m.gameId);
            if (m.gameHead != null && Object.hasOwnProperty.call(m, "gameHead"))
                w.uint32(24).int32(m.gameHead);
            if (m.frameTime != null && Object.hasOwnProperty.call(m, "frameTime"))
                w.uint32(32).int32(m.frameTime);
            if (m.pUidList != null && m.pUidList.length) {
                for (var i = 0; i < m.pUidList.length; ++i)
                    w.uint32(42).string(m.pUidList[i]);
            }
            if (m.pSeatList != null && m.pSeatList.length) {
                w.uint32(50).fork();
                for (var i = 0; i < m.pSeatList.length; ++i)
                    w.int32(m.pSeatList[i]);
                w.ldelim();
            }
            if (m.pNameList != null && m.pNameList.length) {
                for (var i = 0; i < m.pNameList.length; ++i)
                    w.uint32(58).string(m.pNameList[i]);
            }
            return w;
        };

        SSubFpsGameStart.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        SSubFpsGameStart.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.MSG.SSubFpsGameStart();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.msgType = r.int32();
                    break;
                case 2:
                    m.gameId = r.int32();
                    break;
                case 3:
                    m.gameHead = r.int32();
                    break;
                case 4:
                    m.frameTime = r.int32();
                    break;
                case 5:
                    if (!(m.pUidList && m.pUidList.length))
                        m.pUidList = [];
                    m.pUidList.push(r.string());
                    break;
                case 6:
                    if (!(m.pSeatList && m.pSeatList.length))
                        m.pSeatList = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.pSeatList.push(r.int32());
                    } else
                        m.pSeatList.push(r.int32());
                    break;
                case 7:
                    if (!(m.pNameList && m.pNameList.length))
                        m.pNameList = [];
                    m.pNameList.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        SSubFpsGameStart.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        SSubFpsGameStart.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                switch (m.msgType) {
                default:
                    return "msgType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                    break;
                }
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                if (!$util.isInteger(m.gameId))
                    return "gameId: integer expected";
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                if (!$util.isInteger(m.gameHead))
                    return "gameHead: integer expected";
            }
            if (m.frameTime != null && m.hasOwnProperty("frameTime")) {
                if (!$util.isInteger(m.frameTime))
                    return "frameTime: integer expected";
            }
            if (m.pUidList != null && m.hasOwnProperty("pUidList")) {
                if (!Array.isArray(m.pUidList))
                    return "pUidList: array expected";
                for (var i = 0; i < m.pUidList.length; ++i) {
                    if (!$util.isString(m.pUidList[i]))
                        return "pUidList: string[] expected";
                }
            }
            if (m.pSeatList != null && m.hasOwnProperty("pSeatList")) {
                if (!Array.isArray(m.pSeatList))
                    return "pSeatList: array expected";
                for (var i = 0; i < m.pSeatList.length; ++i) {
                    if (!$util.isInteger(m.pSeatList[i]))
                        return "pSeatList: integer[] expected";
                }
            }
            if (m.pNameList != null && m.hasOwnProperty("pNameList")) {
                if (!Array.isArray(m.pNameList))
                    return "pNameList: array expected";
                for (var i = 0; i < m.pNameList.length; ++i) {
                    if (!$util.isString(m.pNameList[i]))
                        return "pNameList: string[] expected";
                }
            }
            return null;
        };

        SSubFpsGameStart.fromObject = function fromObject(d) {
            if (d instanceof $root.MSG.SSubFpsGameStart)
                return d;
            var m = new $root.MSG.SSubFpsGameStart();
            switch (d.msgType) {
            case "SYNC":
            case 0:
                m.msgType = 0;
                break;
            case "HALL":
            case 1:
                m.msgType = 1;
                break;
            case "GAME":
            case 2:
                m.msgType = 2;
                break;
            case "PING":
            case 3:
                m.msgType = 3;
                break;
            case "PONG":
            case 4:
                m.msgType = 4;
                break;
            case "FPS_SYNC":
            case 5:
                m.msgType = 5;
                break;
            }
            if (d.gameId != null) {
                m.gameId = d.gameId | 0;
            }
            if (d.gameHead != null) {
                m.gameHead = d.gameHead | 0;
            }
            if (d.frameTime != null) {
                m.frameTime = d.frameTime | 0;
            }
            if (d.pUidList) {
                if (!Array.isArray(d.pUidList))
                    throw TypeError(".MSG.SSubFpsGameStart.pUidList: array expected");
                m.pUidList = [];
                for (var i = 0; i < d.pUidList.length; ++i) {
                    m.pUidList[i] = String(d.pUidList[i]);
                }
            }
            if (d.pSeatList) {
                if (!Array.isArray(d.pSeatList))
                    throw TypeError(".MSG.SSubFpsGameStart.pSeatList: array expected");
                m.pSeatList = [];
                for (var i = 0; i < d.pSeatList.length; ++i) {
                    m.pSeatList[i] = d.pSeatList[i] | 0;
                }
            }
            if (d.pNameList) {
                if (!Array.isArray(d.pNameList))
                    throw TypeError(".MSG.SSubFpsGameStart.pNameList: array expected");
                m.pNameList = [];
                for (var i = 0; i < d.pNameList.length; ++i) {
                    m.pNameList[i] = String(d.pNameList[i]);
                }
            }
            return m;
        };

        SSubFpsGameStart.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.pUidList = [];
                d.pSeatList = [];
                d.pNameList = [];
            }
            if (o.defaults) {
                d.msgType = o.enums === String ? "SYNC" : 0;
                d.gameId = 0;
                d.gameHead = 0;
                d.frameTime = 0;
            }
            if (m.msgType != null && m.hasOwnProperty("msgType")) {
                d.msgType = o.enums === String ? $root.MSG.MsgType[m.msgType] : m.msgType;
            }
            if (m.gameId != null && m.hasOwnProperty("gameId")) {
                d.gameId = m.gameId;
            }
            if (m.gameHead != null && m.hasOwnProperty("gameHead")) {
                d.gameHead = m.gameHead;
            }
            if (m.frameTime != null && m.hasOwnProperty("frameTime")) {
                d.frameTime = m.frameTime;
            }
            if (m.pUidList && m.pUidList.length) {
                d.pUidList = [];
                for (var j = 0; j < m.pUidList.length; ++j) {
                    d.pUidList[j] = m.pUidList[j];
                }
            }
            if (m.pSeatList && m.pSeatList.length) {
                d.pSeatList = [];
                for (var j = 0; j < m.pSeatList.length; ++j) {
                    d.pSeatList[j] = m.pSeatList[j];
                }
            }
            if (m.pNameList && m.pNameList.length) {
                d.pNameList = [];
                for (var j = 0; j < m.pNameList.length; ++j) {
                    d.pNameList[j] = m.pNameList[j];
                }
            }
            return d;
        };

        SSubFpsGameStart.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SSubFpsGameStart;
    })();

    return MSG;
})();

module.exports = $root;
